import { useEffect, useState } from 'react';
import { Image, type ImageProps } from 'semantic-ui-react';
import { CommonConstant } from '../utility/constants';

interface ISemanticImageWithFallbackProps extends ImageProps {
  fallback?: string;
  src?: string;
}

export function SemanticImageWithFallback({
  fallback = CommonConstant.defaultImage,
  src,
  ...rest
}: ISemanticImageWithFallbackProps) {
  const [imgSrc, setImgSrc] = useState<string | undefined>(src);

  const onError = () => setImgSrc(fallback);

  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  return <Image alt="Skupreme" src={imgSrc || fallback} onError={onError} {...rest} />;
}
